import React from "react";
import { Link } from "react-router-dom";

const ConsultationBanner: React.FC = () => {
  return (
    <section className="w-full relative overflow-hidden bg-[linear-gradient(90deg,rgba(254,230,230,0.5)_0%,rgba(198,3,2,0.5)_100%)] min-h-[440px] lg:h-[484px] flex items-center">
      {/* Visual Wayang di Sisi Kanan (FrontEnd/public/wayang.png) */}
      <div
        className="absolute right-0 top-0 bottom-0 h-full w-full pointer-events-none overflow-hidden flex justify-end items-end z-0"
        data-aos="fade-left"
        data-aos-duration="1000"
      >
        <img
          src="/wayang.png"
          alt="Indonesian Wayang Culture Ornament"
          className="h-[80%] md:h-[86%] lg:h-[103%] w-auto max-w-none object-contain object-right-bottom opacity-85 sm:opacity-95 lg:opacity-100 select-none translate-x-6 sm:translate-x-0"
        />
      </div>

      {/* Konten Kiri (Context): Headline, Subtitle, & Tombol */}
      <div className="max-w-[1440px] w-full mx-auto px-6 sm:px-12 lg:px-[100px] relative z-10 py-12 lg:py-0">
        <div
          className="max-w-[608px] flex flex-col items-start text-left"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          {/* Headline */}
          <h2 className="font-montserrat font-bold text-3xl sm:text-4xl lg:text-[40px] text-[#202020] leading-[1.2] lg:leading-[48px] tracking-tight mb-4">
            Not Sure Which Class Is Right for You?
          </h2>

          {/* Subtitle */}
          <p className="font-montserrat font-normal text-base sm:text-lg lg:text-[20px] text-[#6A6A6A] leading-relaxed lg:leading-[28px] mb-8 lg:mb-[50px] max-w-[560px]">
            Take our free proficiency assessment first to evaluate your skills and find your ideal starting point before registering.
          </p>

          {/* Button Check My Level Now */}
          <Link
            to="/assessment/free-test"
            className="inline-flex items-center gap-2 px-5 py-3.5 bg-[#C60302] hover:bg-[#a50201] text-white font-montserrat font-semibold text-sm rounded-lg shadow-[2px_2px_4px_rgba(32,32,32,0.25)] transition-all duration-200 cursor-pointer active:scale-95 group"
          >
            <span>Check My Level Now</span>
            {/* basil:arrow-right-solid icon */}
            <svg
              className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289L19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071C12.9024 18.3166 12.9024 17.6834 13.2929 17.2929L16.5858 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H16.5858L13.2929 8.70711C12.9024 8.31658 12.9024 7.68342 13.2929 7.29289Z"
                fill="currentColor"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConsultationBanner;
